module.exports = __webpack_public_path__ + "static/gallery_peak_5_thumb-7b5b319a8739683a0bd52d481f6df445.jpg";